const confirmation = {}
confirmation.install = function (Vue, options) {
  Vue.prototype.$confirmation = function (title = 'confirm_question', text = 'confirm_message', type = 'question', cancel_txt_btn = 'No', confirm_txt_btn = 'yes') {
    return swal({
      title: options.language.capitalize(options.language.i18n, title),
      text: options.language.capitalize(options.language.i18n, text),
      type: type,
      showCancelButton: true,
      cancelButtonText: options.language.capitalize(options.language.i18n, cancel_txt_btn),
      confirmButtonText: options.language.capitalize(options.language.i18n, confirm_txt_btn)
    })
  }
}

export default confirmation



// WEBPACK FOOTER //
// app/javascript/src/plugins/confirmation/confirmation.js